import { makeStyles } from "@material-ui/styles";
import classNames from "classnames";
import * as React from "react";

interface StepsIndicatorProps<T> {
  amount: number;
  errorBlocks: Array<T>;
  successBlocks: Array<T>;
}

export const StepsIndicator: React.FC<StepsIndicatorProps<string | number>> = ({
  amount = 1,
  errorBlocks = [],
  successBlocks = [],
}) => {

  const classes = useStyles();
  return (
    <div className={classes.root}>
      {Array.from({length: amount}, (_, k) => (
        <div key={k} className={classNames({
          [classes.block]: true,
          [classes.successBlock]: successBlocks.includes(k) ? true : false,
          [classes.errorBlock]: errorBlocks.includes(k) ? true : false,

        })}>
        </div>
      ))}
    </div>
  )
}


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    flexWrap: 'nowrap',
    gap: 4,
  },
  block: {
    flex: 1,
    borderRadius: 2,
    backgroundColor: '#F0F7FD',
    height: 22,
  },
  errorBlock: {
    backgroundColor: '#FF8227',
  },
  successBlock: {
    backgroundColor: '#2F90E0',
  },

}))